import { Component, Input, OnInit } from '@angular/core';
import { finalize } from 'rxjs/operators';
import { AlcmeonContextService } from 'src/app/core/alcmeon-context/alcmeon-context.service';

import { BasicService } from 'src/app/shared/services/basic.service';
import { AgentShortcut } from './agent-shortcut.model';
import { AgentShortcutService } from './agent-shortcut.service';

@Component({
  selector: 'app-agent-shortcuts-modal',
  templateUrl: './agent-shortcuts-modal.component.html',
  styleUrls: ['./agent-shortcuts-modal.component.scss'],
})
export class AgentShortcutsModalComponent implements OnInit {
  @Input() siteId: number;

  loading: boolean;
  list: AgentShortcut[];

  constructor(
    public basicService: BasicService,
    private agentShortcutService: AgentShortcutService,
    private alcmeonContextService: AlcmeonContextService
  ) {}

  ngOnInit() {
    this.loading = true;
    this.agentShortcutService
      .getAgentShortcuts(this.alcmeonContextService.companyId, this.siteId)
      .pipe(finalize(() => (this.loading = false)))
      .subscribe({
        next: (agentShortcuts: AgentShortcut[]) => (this.list = agentShortcuts),
      });
  }
}
